import { IContact, IContactAddress, IContactArgs } from "./contact.types"
import { THE_ESTATE_OF } from "@/constants/deceased"
import { includes, toDisplayName } from "@/helpers/stringHelpers"

export class Contact implements IContact {
  juniferContactId: number
  juniferAccountContactId: number
  contactType: string
  title: string
  firstName: string
  lastName: string
  email: string
  phone1: string
  phone2: string | null
  phone3: string | null
  juniferPrimaryContact: boolean
  receiveEmail: boolean | null
  receivePost: boolean | null
  receiveSMS: boolean | null
  billDelivery: string
  dateOfBirth: string
  address: IContactAddress | null

  constructor(args: IContactArgs) {
    this.juniferContactId = args.juniferContactId
    this.juniferAccountContactId = args.juniferAccountContactId
    this.contactType = args.contactType
    this.title = args.title
    this.firstName = args.firstName
    this.lastName = args.lastName
    this.email = args.email
    this.phone1 = args.phone1
    this.phone2 = args.phone2
    this.phone3 = args.phone3
    this.juniferPrimaryContact = args.juniferPrimaryContact
    this.receiveEmail = args.receiveEmail
    this.receivePost = args.receivePost
    this.receiveSMS = args.receiveSMS
    this.billDelivery = args.billDelivery
    this.dateOfBirth = args.dateOfBirth
    this.address = args.address
  }

  /*
    Composed in the FE: the gateway has no full-name field, and ark's was
    title-cased at sync time. Display only — the raw firstName/lastName stay
    exactly as Junifer stores them, so an edit never normalises a name by
    accident.
  */
  get fullName(): string {
    return [this.title, this.firstName, this.lastName]
      .map(toDisplayName)
      .filter(Boolean)
      .join(" ")
  }

  get isDeceased(): boolean {
    return includes(this.firstName, THE_ESTATE_OF)
  }

  get isOccupier(): boolean {
    return this.lastName.toLowerCase() === "occupier"
  }
}

export const getEmptyContact = () =>
  new Contact({
    juniferContactId: 0,
    juniferAccountContactId: 0,
    contactType: "",
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    phone1: "",
    phone2: null,
    phone3: null,
    juniferPrimaryContact: false,
    receiveEmail: null,
    receivePost: null,
    receiveSMS: null,
    billDelivery: "",
    dateOfBirth: "",
    address: null,
  })
